export default function displayWinParcelInfo(results) {
    let s = `<h2>Parcel Info</h2>`;

    if (results?.features?.length)
    {
        s = "";
        let features = results.features; 

        features.forEach(feature => {
            let featAtt = feature.attributes; 
            if (featAtt.OptOut == "Y")
            {
                s += "This parcel has opted out of WinGIS Services.";
            }
            else {
                s += `         
                    <h2>
                        ${featAtt['LOPHouseNumber']} ${featAtt['LOPPrefixDirectional']} ${featAtt['LOPStreetName']} ${featAtt['LOPStreetSuffix']}
                    </h2>
                    <table>
            
                        <thead>
                            <th>
                                <b>
                                    Pin
                                </b>
                            </th>
                            <th>
                                Alt.Pin
                            </th>
                            <th>
                                <b>Property Size</b>
                            </th>
                        </thead>
                        <tr>
                            <td>
                                ${featAtt['PIN']}
                            </td>
                            <td>
                                ${featAtt['AltParcelNumber']}
                            </td>
                            <td>
                                Sq. Feet: ${(featAtt['Shape.area'] / 1).toFixed(0)} 
                                | Acres: ${(featAtt['Shape.area'] / 43560).toFixed(2)}
                            </td>
                        </tr>
                        <tr>
                            <td colspan='3'>
                                <b>Legal Description</b>
                                <br />${featAtt['LegalDesc']}
                            </td>
                        </tr>
                    </table>`; 
            }
        });


             
        
    }
    else 
    {
        s += `<p>Unable to get parcel info. Refresh the page and contact us if this issue persists.</p>`
    }
    return s;        
   

}
